// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2XH3X","active":"Item_active__U-i3x"};